export var CallType;
(function (CallType) {
    CallType["audio"] = "audio";
    CallType["video"] = "video";
    CallType["api"] = "api";
})(CallType || (CallType = {}));
//# sourceMappingURL=types.js.map